import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProdutoVersaoAtributoEntity } from '@catalogo/models';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root', })
export class ProdutoVersaoAtributosDataService extends CrudService<ProdutoVersaoAtributoEntity[]> {

  protected url: string;
  private urlReplace: string;

  constructor(
    @Inject(OPERACAO_API_URL) public urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.urlReplace = `${urlBase}/v1/produto/<parent>/VersaoAtributos`;
  }

  public withParentId(id) {
    this.url = this.urlReplace.replace('<parent>', id);
    return this;
  }

}
